import { ApiResponse } from '@interfaces/api';
import { SellingOffersNegotiationData, SellingOffersNegotiationListResponse } from '../domain/SellingOffersNegotiation';
import { SellingOffersNegotiationDataDTO } from '../dtos/SellingOffersNegotiationDTO';

const mapNegotiationData = (dataDTO: SellingOffersNegotiationDataDTO): SellingOffersNegotiationData => {
  const { id, lastAction, negotiationStatus, buyer, hasBestOffer } = dataDTO;
  return {
    id: id,
    negotiationStatus: {
      callerMessage: negotiationStatus.callerMessage,
      callerSubMessage: negotiationStatus.callerSubMessage,
      isAccepted: negotiationStatus.isAccepted,
      isClosed: negotiationStatus.isClosed,
      callerRemainingActionsNumber: negotiationStatus.callerRemainingActionsNumber,
      callerPossibleActions: negotiationStatus.callerPossibleActions,
    },
    lastAction: {
      originator: lastAction.originator,
      offerFormatted: lastAction.offerFormatted,
      offerSellerEarningsFormatted: lastAction.offerSellerEarningsFormatted,
      actionNote: lastAction.actionNote,
      action: lastAction.action,
    },
    buyer: {
      id: buyer.id,
      name: buyer.name,
      picturePath: buyer.picturePath,
    },
    hasBestOffer: hasBestOffer,
  };
};

export const mapSellingOffersNegotiationListResponse = (
  dto: ApiResponse<SellingOffersNegotiationDataDTO[]>,
): SellingOffersNegotiationListResponse => {
  return {
    data: dto.data.map(mapNegotiationData),
    meta: dto.meta,
  };
};
